import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]
  static values = { delay: { type: Number, default: 3000 } }

  // Only a success clears itself.
  //
  // An error or warning that removes itself on a timer is a time limit the content sets, and
  // WCAG 2.2 2.2.1 Timing Adjustable (level A) allows one only if the reader can turn it off,
  // adjust it, or extend it. A floating alert offered none of the three, and none of 2.2.1's
  // exceptions apply. Nine seconds is also short for anyone reading slowly, magnifying, or
  // translating as they go. CU-1248uf3ty73.
  //
  // Floating is untouched. 2.2.1 objects to the timer, not the position — an alert that stays
  // until dismissed is still an overlay, still out of the flow, still not moving the layout.
  //
  // Note what this did NOT change: an *inline* error already never auto-dismissed, because the
  // old guard returned early for it. The 9s only ever applied to alerts carrying
  // `sa-alert-flash`, so it was the floating flag doing this rather than any decision taken
  // about errors.
  buttonTargetConnected() {
    this.clearTimer()
    if (!this.element.classList.contains('alert-success')) { return }

    this.timer = setTimeout(() => {
      try { this.buttonTarget.click() } catch (_e) {}
    }, this.delayValue)
  }

  disconnect() {
    this.clearTimer()
  }

  clearTimer() {
    if (this.timer) { clearTimeout(this.timer); this.timer = null }
  }
}
